export const ROLES = {
  UNDEFINED: 0,
  PERSONAL_SERVICE: 1,
  PAYMENTS: 2,
  MASTER: 3,
  AGENT: 4,
  AFFILIATE: 5,
  MANAGEMENT: 7,
  SERVICE_BOSS: 8,
  PAYMENTS_ACCOUNTING: 9,
  ACCOUNTING: 10,
  PAYMENTS_BOSS: 11,
  RISK: 12,
  HOLDERS: 13,
  ATC_CLOSURES: 15,
  ATC_PAYMENTS: 16,
  BILLING: 17,
  MISC_SERVICES: 18,
  SYSTEMS: 19,
  MARKETING: 20,
  ADMIN_ZG: 21,
  MARKETING_ANALYST: 22,
  DATA_SCIENCE: 23,
  DESIGN: 24,
  PROJECT_SORTI: 25,
  PROJECT: 26,
  VIEWS: 30,
};

export const USER_TYPES: { [key: string]: string } = {
  MASTER: '0',
  ADMINISTRATOR: '1',
  TRANSACCTIONS: '2',
  AGENT_LEVEL_ONE: '3',
  AGENT_LEVEL_TWO: '4',
  AGENT_LEVEL_THREE: '5',
};

export const USER_TYPES_NAMES = {
  AGENT: 'Agente',
  AFFILIATE: 'Agente Afiliador',
};

export const MAIN_PERMISSIONS: { [key: string]: number } = {
  'Cargas y Retiros': 1,
  'Abonos y Pagos': 2,
  Reporte: 3,
  Contabilidad: 4,
  Auditoria: 5,
  Perfil: 6,
  Dashboard: 7,
  Usuarios: 8,
  Facturacion: 9,
  Bonos: 10,
  Marketing: 11,
  Bot: 12,
  'Roles y Permisos': 13,
  Deudas: 14,
  Balance: 15,
  Debt: 16,
  RRHH: 51,
  SupportZgames: 54,
};

export const SUB_PERMISSIONS: { [key: string]: number } = {
  Sub_Modulo_Auditoria: 17,
  Sub_Modulo_Configuracion_Auditoria: 263,
  Sub_Modulo_Agentes: 39,
  Sub_Modulo_Titulares: 40,
  Sub_Modulo_Administrativos: 41,
  Sub_Modulo_Financiero: 42,
  Sub_Modulo_Lista_CR: 43,
  Sub_Modulo_Lista_AP: 44,
  Sub_Modulo_Transaccion_Banco: 45,
  Sub_Modulo_Solicitar_CR: 46,
  Sub_Modulo_Cierre: 47,
  Sub_Modulo_Administracion_Cierre: 176,
  Sub_Modulo_Diario: 48,
  Sub_Modulo_Bot: 49,
  Sub_Modulo_Bono_Saldos: 50,
  Sub_Modulo_Codigo_Bonos: 51,
  Sub_Modulo_Bancario: 52,
  Sub_Modulo_Lista_Deuda: 54,
  Sub_Consultar_Modulos_Permisos: 53,
  Set_Password_Agent: 68,
  Block_Agents: 69,
  Sub_Modulo_Roles: 56,
  Sub_Modulo_Jugadores: 83,
  Sub_Modulo_Cuentas: 84,
  Sub_Modulo_Nominas: 92,
  Sub_Modulo_PageBalance: 93,
  Sub_Modulo_Permisos_Empleados: 94,
  Sub_Modulo_Bancario_Reporte_Bancario: 109,
  Sub_Modulo_Bancario_Cuentas_Bancarias: 110,
  Sub_Modulo_Bancario_Bancos: 111,
  Sub_Modulo_Documentos_Contables: 115,
  Sub_Modulo_Documentos_Contables_Diario: 116,
  Sub_Modulo_Plantilla: 144,
  Sub_Modulo_Pregunta: 145,
  Sub_Modulo_Opciones: 146,
  Sub_Modulo_Reporte: 147,
  Sub_Module_Promotional_Material: 150,
  Sub_Module_Marketing: 151,
  Sub_Module_Prediction: 152,
  Sub_Module_Referrals_Link: 164,
  Sub_Module_Insert_Feedback: 169,
  Sub_Module_Manage_Feedback: 170,
  Sub_Module_Referrals_links_Ver_Todos: 171,
  Sub_Module_Referrals_links_Filtrar_Usuarios: 173,
  Sub_modulo_solicitud_Agencia: 174,
  Sub_Modulo_Agentes_Verificados: 175,
  Sub_Module_Send_Support_Zgames_Ticket: 262,
  Sub_Modulo_Gestion_cierre: 181,
  Sub_Modulo_Gestion_Bonos: 237,
};

export const BOT_EXTRACT_PERMISSION_NAMES = {
  ViewModule: 'Ver Modulo Extractos Bancarios',
  Consult: 'Consultar Extractos Bancarios',
  Execute: 'Ejecutar Extracto Bancario',
  SendOtp: 'Enviar OTP Extracto Bancario',
  ViewBalance: 'Ver Saldos Extractos Bancarios',
  ExportBalanceSummary: 'Exportar Resumen Saldos Bot',
} as const;

export const BANK_ACCOUNT_PERMISSION_NAMES = {
  EditConfirmationModal: 'Modal de confirmacion de edicion',
} as const;
